export enum DiagnosisTreatmentSearch {
  diagnosis = 0,
  treatment = 1,
  surgeon = 2,
  visit_types = 3,
  procedure_types = 4,
  body_part = 5,
  area = 6,
  implant_volume = 7,
  implant_plane = 8,
  bmi = 9,
  skin_tone = 10,
}
